import { configureStore } from '@reduxjs/toolkit';
import { TypedUseSelectorHook, useDispatch, useSelector } from 'react-redux';
import { CombinedState, ReducersMapObject } from 'redux';
import { reducers } from './reducers';

export const store = configureStore({
  reducer: reducers,
});

export type RootState = typeof reducers extends ReducersMapObject<infer S>
  ? CombinedState<S>
  : never;
export const useTypedSelector: TypedUseSelectorHook<RootState> = useSelector;

export const useAppDispatch = () => useDispatch<typeof store.dispatch>();
